<template>
  <div class="commodity-tag">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品标签</span>
      </template>
      <template v-slot:content>
        <div class="commodity-tag-main">
          <!-- <div class="title">管理您的商品标签，最多支持5个标签；标签内容最多支持5个字符（汉字、英文或数字）</div> -->
          <div class="title">管理您的商品标签，最多支持10个标签；标签内容最多支持5个字符（汉字、英文或数字）</div>
          <div class="tag-container">
            <div class="tag">
              <el-tag :key="index" v-for="(tag,index) in dynamicTags" :disable-transitions="true">
                <i class="change" @click="handleClose(index)"></i>
                {{tag.name}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              ></el-input>
                <!-- :class="dynamicTags.length>=5?'btn-white none':'btn-white'" -->
              <el-button
                :class="dynamicTags.length>=10?'btn-white none':'btn-white'"
                v-else
                size="small"
                @click="showInput"
              >+ 添加</el-button>
            </div>
            <div class="save">
              <el-button class="btn-blue" @click="save">保存</el-button>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBCommodity from 'models/db/commodity.js';
const dbCommodity = new DBCommodity();
export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    this.getLabel();
  },
  methods: {
    // 获取标签数据
    getLabel() {
      dbCommodity.getDBLabel().then(res => {
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.labelName;
            this.dynamicTags.push(obj);
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 保存修改
    save() {
      if (!this.inputVisible) {
        let arr = [];
        for (let i = 0; i < this.dynamicTags.length; i++) {
          if (this.dynamicTags[i].name && !!this.dynamicTags[i].id) {
            let obj = {};
            obj.id = this.dynamicTags[i].id;
            obj.labelName = this.dynamicTags[i].name;
            arr.push(obj);
          } else if (this.dynamicTags[i].name && !this.dynamicTags[i].id) {
            let obj = {};
            obj.labelName = this.dynamicTags[i].name;
            arr.push(obj);
          }
        }
        dbCommodity.postDBUpdateLabel(arr).then(res => {
          if (res.success) {
            this.dynamicTags = [];
            this.getLabel();
            this.$message.success('保存成功');
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 删除
    handleClose(index) {
      if (this.dynamicTags[index].id) {
        let id = this.dynamicTags[index].id;
        dbCommodity.postDBDeleteLabel(id).then(res => {
          if (res.success) {
            this.dynamicTags.splice(index, 1);
          }
        });
      } else {
        this.dynamicTags.splice(index, 1);
      }
    },
    // 显示输入框
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 失去焦点进行判断
    handleInputConfirm() {
      let inputValue = this.inputValue;
      let reg = /^[\u4E00-\u9FA5A-Za-z0-9_]{0,5}$/;
      let stop = false;
      this.dynamicTags.map(value => {
        if (value.name === inputValue) {
          stop = true;
        }
      });
      if (reg.test(inputValue)) {
        if (inputValue === '') {
          this.inputVisible = false;
          this.inputValue = '';
        } else if (stop) {
          this.$message.error('标签不能重复！');
        } else {
          this.dynamicTags.push({
            name: inputValue
          });
          this.inputVisible = false;
          this.inputValue = '';
        }
      } else {
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
        this.$message.error('最多支持5个字符');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.commodity-tag {
  width: 100%;
  height: 100%;
  .commodity-tag-main {
    letter-spacing: 1px;
    .title {
      height: 22px;
      line-height: 22px;
      color: #909399;
      margin-bottom: 23px;
      font-size: 14px;
    }
    .tag-container {
      .tag {
        height: 32px;
        margin-bottom: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-tag {
          text-align: center;
          height: 32px;
          width: 96px;
          border-radius: 4px;
          background: #fff;
          color: #919398;
          border: 1px dashed rgba(221, 223, 230, 1);
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          .change {
            position: absolute;
            width: 16px;
            height: 16px;
            background: url(../../../../assets/images/remove.png);
            background-size: cover;
            top: -8px;
            left: 85px;
            display: none;
          }
        }
        .el-tag:hover {
          .change {
            display: block;
          }
        }
        .btn-white {
          width: 96px;
          font-size: 12px;
        }
        .none {
          display: none;
        }
        .input-new-tag {
          width: 96px;
        }
      }
      .save {
        .el-button {
          width: 96px;
          height: 32px;
          background: #3d74f2;
          color: #fff;
          line-height: 0px;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
